<script lang="ts" setup>
import { computed, PropType } from "vue";
import { TaskModel } from "@/components/tasks-kanban/models";
import { ListItemModel } from "../../../models";
import { TaskCardItemWrapper } from "./";
import { TaskParameter, TaskParameterTypeEnum } from "@/components/task-parameter";

/**Параметры */
const props = defineProps({
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
});

/**Первый тег */
const firstTag = computed(() => props.task.Tags?.[0]);
/**Скрытые тэги */
const hiddenTags = computed(() => Math.max(props.task.Tags.length - 1, 0));
</script>
<template>
  <TaskCardItemWrapper :element="element">
    <TaskParameter v-if="firstTag" preview :data="firstTag" :type="TaskParameterTypeEnum.Tag" />
    <div v-if="hiddenTags" v-text="`+${hiddenTags}`" class="task-card_circle" />
  </TaskCardItemWrapper>
</template>
